import type { Work } from "@/types/media";

export const works: Work[] = [
  {
    id: "m-echo",
    title: "回声之井",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "剧情", "心理"],
    rating: 8.6,
    director: "林暐",
    cast: ["沈砚", "陆知遥", "周牧"],
    duration: "128 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20thriller%20movie%20poster%20artwork%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grading%2C%20lone%20silhouette%20standing%20before%20a%20misty%20stone%20well%2C%20low%20key%20dramatic%20lighting%2C%20mysterious%20moody%20atmosphere%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=echo-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%2C%20misty%20empty%20courtyard%20with%20an%20old%20stone%20well%20at%20dusk%2C%20deep%20navy%20sky%20with%20warm%20orange%20lantern%20glow%2C%20atmospheric%20fog%2C%20moody%20low%20key%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=echo-backdrop-01&orientation=landscape",
    synopsis:
      "小镇接连发生失忆事件，一切都指向村口那口被水泥封存的旧井。返乡的心理咨询师苏未决定揭开真相，却在挖掘记忆的过程中发现，被封印的或许不是井，而是每个人不愿面对的过去。",
    plot: [
      {
        title: "第一章 · 失忆的镇子",
        content:
          "回乡参加父亲葬礼的苏未发现，镇上的居民几乎都对三十年前的一场大火闭口不谈。唯独老邮差反复念叨一句话：井盖下面，住着回声。",
      },
      {
        title: "第二章 · 水泥下的名字",
        content:
          "苏未与当年的目击者逐一交谈，拼凑出七个被刻意抹去的名字。随着调查深入，她自己的童年记忆也开始出现裂痕。",
      },
      {
        title: "第三章 · 谁在说谎",
        content:
          "当唯一愿意开口的证人也在夜里消失，苏未意识到，真正封锁真相的不是凶手，而是整个镇子共同选择的沉默。",
      },
      {
        title: "第四章 · 回声与和解",
        content:
          "井盖被重新掀开的那一刻，回声终于有了出口。苏未没有指认任何人，而是选择让被掩盖的往事被听见——这才是真正的破案。",
      },
    ],
    tags: ["烧脑", "人性", "高口碑"],
  },
  {
    id: "m-border",
    title: "边境来信",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "历史", "战争"],
    rating: 8.9,
    director: "陈望舒",
    cast: ["高砚舟", "秦澜", "叶知秋"],
    duration: "142 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20war%20movie%20poster%2C%20muted%20navy%20and%20amber%20color%20grading%2C%20soldier%20reading%20a%20letter%20in%20a%20snowy%20border%20outpost%2C%20volumetric%20cold%20light%2C%20solemn%20epic%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=border-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%2C%20snowy%20mountain%20border%20outpost%20at%20blue%20hour%2C%20distant%20warm%20lamplight%20in%20a%20watchtower%20window%2C%20vast%20cold%20landscape%2C%20epic%20atmospheric%20composition%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=border-backdrop-01&orientation=landscape",
    synopsis:
      "一封迟到了四十年的信，让退役老兵重新踏上当年的巡逻路线。沿途的每一个路标，都记录着一段被历史尘封的青春与抉择。",
    plot: [
      {
        title: "第一章 · 迟到的邮包",
        content:
          "拆开泛黄的邮包，老人认出那竟是当年班长托付却从未寄出的家书。信中夹着一张坐标纸条，指向早已从地图上消失的哨所。",
      },
      {
        title: "第二章 · 重走巡逻路",
        content:
          "他独自重返边境，雪线之下的每一步都与记忆重叠。年轻旅店老板娘的追问，逼着他第一次讲述那段无人知晓的驻守岁月。",
      },
      {
        title: "第三章 · 未送达的名字",
        content:
          "哨所遗址旁的石堆下，埋着一个铁盒，里面是二十七个从未被送出的名字。他终于明白，自己背负的不是一封信，而是一整代人的嘱托。",
      },
      {
        title: "第四章 · 把信寄出去",
        content:
          "老人将信件逐一投递，在邮局门口站了很久。历史或许沉默，但只要还有人愿意寄出，那些名字就不会真正消失。",
      },
    ],
    tags: ["史诗", "催泪", "获奖作品"],
  },
  {
    id: "m-neon",
    title: "霓虹尽头",
    type: "movie",
    year: 2025,
    region: "中国香港",
    genres: ["犯罪", "悬疑", "黑色"],
    rating: 8.2,
    director: "何家骏",
    cast: ["阮澄", "裴朗", "苏晚晴"],
    duration: "116 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20neo%20noir%20crime%20movie%20poster%2C%20wet%20neon%20alleys%20with%20orange%20and%20deep%20blue%20reflections%2C%20silhouette%20in%20a%20trench%20coat%2C%20rain%20slicked%20street%2C%20high%20contrast%20moody%20lighting%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=neon-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%2C%20rainy%20night%20city%20street%20with%20glowing%20orange%20signs%20reflected%20in%20puddles%2C%20deep%20blue%20shadows%2C%20lonely%20figure%20walking%20away%2C%20neo%20noir%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=neon-backdrop-01&orientation=landscape",
    synopsis:
      "沉迷赌局的摄影师意外拍下一桩连环案的唯一证据，从此被卷入城市霓虹照不到的另一面。要活下来，他必须先弄清楚自己究竟拍到了什么。",
    plot: [
      {
        title: "第一章 · 底片里的第三个人",
        content:
          "阿澄冲印废片时发现，每张照片里都多出一个不该存在的背影。他起初以为是显影失误，直到照片里的地方接连出事。",
      },
      {
        title: "第二章 · 被追的证人",
        content:
          "陌生人开始跟踪他，警方却将他视为嫌疑人。为了自证，他只能一边躲避，一边把散落的照片拼回完整的时间线。",
      },
      {
        title: "第三章 · 霓虹照不到的角落",
        content:
          "线索指向一位替他洗过照片的老店主。真相是他拍的从来不是凶案，而是一场长达十年的报复计划。",
      },
      {
        title: "第四章 · 把镜头交给光",
        content:
          "最后一张照片，他选择了对准自己。真相公开的那一刻，他第一次觉得，镜头也可以不是罪证，而是出口。",
      },
    ],
    tags: ["港风", "反转", "犯罪片"],
  },
  {
    id: "m-migrate",
    title: "候鸟计划",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "剧情", "冒险"],
    rating: 8.4,
    director: "程亦然",
    cast: ["顾承", "温若", "邵阳"],
    duration: "134 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%2C%20deep%20navy%20space%20and%20warm%20orange%20star%20glow%2C%20astronaut%20looking%20at%20a%20swarm%20of%20migrating%20birds%20composed%20of%20light%2C%20awe%20inspiring%2C%20clean%20high%20contrast%20composition%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=migrate-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20sci%20fi%20film%20still%2C%20vast%20dark%20desert%20under%20an%20enormous%20starry%20sky%2C%20a%20faint%20warm%20orange%20glow%20on%20the%20horizon%2C%20lone%20scientific%20outpost%2C%20epic%20atmospheric%20scale%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=migrate-backdrop-01&orientation=landscape",
    synopsis:
      "地球磁场即将崩解的年代，一支科考队追踪一群「会发光的候鸟」，试图找到重启大气系统的最后坐标。他们很快发现，候鸟记住的其实是人类的过去。",
    plot: [
      {
        title: "第一章 · 会发光的鸟群",
        content:
          "监测站捕捉到一批迁徙轨迹异常的鸟群，它们发光、无声，并且每年都在同一秒改变航向，像在执行某个古老的指令。",
      },
      {
        title: "第二章 · 坐标与记忆",
        content:
          "队长顾承发现，鸟群的飞行路线与四十年前一次失败的实验记录完全吻合。候鸟，是被写在天空里的备忘录。",
      },
      {
        title: "第三章 · 要不要按下重启",
        content:
          "重启大气需要牺牲仅存的能源储备，也意味着放弃返回家园的机会。团队在绝境中做出了分裂而痛苦的抉择。",
      },
      {
        title: "第四章 · 方向由谁决定",
        content:
          "当第一道绿光升起，候鸟再次起飞。电影没有给出标准答案，只留下一个问题：当旧世界回不去时，我们该怎么定义家。",
      },
    ],
    tags: ["硬科幻", "口碑黑马", "哲思"],
  },
  {
    id: "m-lighthouse",
    title: "灯塔上的誓言",
    type: "movie",
    year: 2022,
    region: "中国台湾",
    genres: ["爱情", "剧情"],
    rating: 7.9,
    director: "许亦宁",
    cast: ["江砚", "宋知夏", "林可言"],
    duration: "108 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20movie%20poster%2C%20warm%20sunset%20orange%20and%20muted%20navy%20sea%2C%20a%20lighthouse%20on%20a%20cliff%2C%20two%20small%20distant%20figures%2C%20tender%20nostalgic%20mood%2C%20soft%20natural%20light%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=lighthouse-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%2C%20white%20lighthouse%20on%20a%20rocky%20cliff%20above%20a%20calm%20sea%20at%20golden%20sunset%2C%20warm%20orange%20sky%20fading%20into%20deep%20blue%2C%20romantic%20serene%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=lighthouse-backdrop-01&orientation=landscape",
    synopsis:
      "守塔人的女儿与一名每年只来一次的摄影师，在灯塔下约定了一个只有他们才懂的日期。多年后，一个人回来了，另一个人把誓言留在了光里。",
    plot: [
      {
        title: "第一章 · 每年一次的船",
        content:
          "每年夏末，灯塔都会迎来同一个人。他不拍照，只是安静地看海，直到守塔人的女儿递给他第一杯热茶。",
      },
      {
        title: "第二章 · 约定",
        content:
          "两人约好，等灯塔的光可以照到对岸那天，就一起离开小岛。约定写在一张便签上，贴在旋转的灯里。",
      },
      {
        title: "第三章 · 有人没来",
        content:
          "约定的那年，船没有靠岸。知夏守着灯塔，把每一年的等待都过成了同一个夏天。",
      },
      {
        title: "第四章 · 光替他来了",
        content:
          "很多年后，一封迟到的信和一台旧相机到了岛上。她没有哭，只是把灯擦得更亮——因为她知道，誓言从未失约。",
      },
    ],
    tags: ["治愈", "慢剧情", "海边"],
  },
  {
    id: "t-river",
    title: "长河落日",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["历史", "剧情", "正剧"],
    rating: 9.1,
    director: "宋之衡",
    cast: ["傅珩", "白榆", "程立", "陆青"],
    duration: "共 42 集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20epic%20tv%20poster%2C%20deep%20navy%20robe%20figure%20before%20a%20vast%20river%20at%20sunset%2C%20warm%20orange%20sky%2C%20ancient%20chinese%20costume%20drama%2C%20solemn%20grand%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=river-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%2C%20a%20great%20river%20under%20a%20huge%20setting%20sun%2C%20silhouettes%20of%20ancient%20city%20walls%20and%20boats%2C%20warm%20orange%20and%20deep%20blue%20sky%2C%20epic%20historical%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=river-backdrop-01&orientation=landscape",
    synopsis:
      "大河东岸，一个寒门学子用二十年时间，从私塾抄书走到朝堂中枢。这部剧讲的不是权谋的胜利，而是一个普通人在时代洪流中的挣扎与坚守。",
    plot: [
      {
        title: "第 1 集 · 抄书少年",
        content:
          "傅珩替人抄书糊口，却因一次替考风波被赶出书院。命运第一次让他明白，出身是可以被规则碾碎的东西。",
      },
      {
        title: "第 8 集 · 入幕",
        content:
          "他投奔边关幕府，靠一封策论得到赏识。初入仕途的他坚信，只要把事做好，就能改变一点什么。",
      },
      {
        title: "第 21 集 · 分歧",
        content:
          "昔日挚友站到了他的对立面。两人在河堤上争论到深夜，谁也没能说服谁——真正的分裂，从来不是因为恶意。",
      },
      {
        title: "第 42 集 · 长河落日",
        content:
          "功成名就之后，他独自回到当年的书院。落日沉入长河，他终于承认，有些东西他改变不了，但他守住了自己。",
      },
    ],
    tags: ["正剧", "高分", "群像"],
  },
  {
    id: "t-forest",
    title: "雾林迷案",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "推理"],
    rating: 8.7,
    director: "路野",
    cast: ["裴知寒", "许南", "阮清"],
    duration: "全 24 集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20crime%20tv%20poster%2C%20dense%20foggy%20pine%20forest%20in%20deep%20blue%2C%20a%20single%20warm%20orange%20flashlight%20beam%2C%20detective%20silhouette%2C%20eerie%20suspenseful%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=forest-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%2C%20foggy%20mountain%20forest%20at%20dawn%2C%20layered%20pine%20trees%20fading%20into%20mist%2C%20deep%20blue%20tones%20with%20a%20faint%20warm%20orange%20glow%2C%20tense%20mysterious%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=forest-backdrop-01&orientation=landscape",
    synopsis:
      "一场大雾封住了通往山岭的每一条路，也让一桩十年前的失踪案重新回到人们视线。刑警裴知寒发现，当年所有证人都说了一部分真话，却拼出了完整的假象。",
    plot: [
      {
        title: "第 1 集 · 雾来了",
        content:
          "山岭封路当天，一名旅人被发现在废弃林场身亡。现场唯一的线索，是一枚属于十年前的旧车票。",
      },
      {
        title: "第 6 集 · 每个人的真话",
        content:
          "裴知寒逐一走访当年的五位当事人。五份都成立的证词，却指向六个互相矛盾的时间点。",
      },
      {
        title: "第 14 集 · 假象的形状",
        content:
          "他意识到，真相不是被藏起来的，而是被所有人共同「对齐」出来的。打破它，只需要一个人肯说完整。",
      },
      {
        title: "第 24 集 · 雾散之后",
        content:
          "大雾散去，山路重新打开。案件结了，但真正被治好的，是整座山岭十年不敢提起的沉默。",
      },
    ],
    tags: ["本格推理", "烧脑", "单元剧"],
  },
  {
    id: "t-city",
    title: "不夜城手记",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["都市", "情感", "群像"],
    rating: 8.0,
    director: "顾萧",
    cast: ["叶昭", "沈云", "黎川", "安夏"],
    duration: "全 36 集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20tv%20poster%2C%20night%20city%20skyline%20in%20deep%20blue%20with%20scattered%20warm%20orange%20windows%2C%20a%20lone%20figure%20on%20a%20rooftop%2C%20reflective%20melancholic%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=city-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%2C%20rainy%20city%20skyline%20at%20night%2C%20deep%20blue%20buildings%20with%20warm%20orange%20window%20lights%2C%20reflections%20on%20wet%20streets%2C%20urban%20loneliness%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=city-backdrop-01&orientation=landscape",
    synopsis:
      "写字楼、出租屋、深夜便利店——同一座城市的四段人生在夜里交汇。他们互不相识，却都在为同一件小事努力：留下来。",
    plot: [
      {
        title: "第 1 集 · 加班到天亮",
        content:
          "四个陌生人的命运，从一个凌晨四点的便利店开始交汇。有人刚失业，有人刚到这座城市，有人正准备离开。",
      },
      {
        title: "第 12 集 · 出租屋的灯",
        content:
          "为了省房租，他们成了临时室友。鸡毛蒜皮的摩擦里，慢慢长出比血缘更可靠的默契。",
      },
      {
        title: "第 25 集 · 各奔东西",
        content:
          "城市给了他们机会，也逼他们做出取舍。有人升职，有人离开，有人终于说出了迟来的告白。",
      },
      {
        title: "第 36 集 · 不夜的手记",
        content:
          "多年后，便利店还在，招牌换了颜色。他们各自散落在城市不同角落，却仍会在深夜想起那盏一直亮着的灯。",
      },
    ],
    tags: ["都市", "治愈", "烟火气"],
  },
  {
    id: "t-star",
    title: "星尘列车",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "悬疑", "冒险"],
    rating: 8.5,
    director: "商昱",
    cast: ["祁野", "温以宁", "唐山", "芮禾"],
    duration: "全 30 集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20mystery%20tv%20poster%2C%20a%20futuristic%20train%20streaking%20through%20deep%20navy%20space%20with%20warm%20orange%20engine%20glow%2C%20glowing%20stars%2C%20sense%20of%20motion%2C%20high%20contrast%20clean%20composition%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=star-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20sci%20fi%20film%20still%2C%20a%20long%20streamlined%20train%20crossing%20a%20nebula%20of%20deep%20blue%20and%20warm%20orange%20stardust%2C%20vast%20cosmic%20scale%2C%20awe%20inspiring%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=star-backdrop-01&orientation=landscape",
    synopsis:
      "一趟横穿星系的列车，每一节车厢都是一个独立的世界。乘客们被告知终点站是故乡，却没人记得自己究竟从哪里上车。",
    plot: [
      {
        title: "第 1 集 · 检票",
        content:
          "祁野在铺位上醒来，口袋里只有一张没有始发站的车票。列车员微笑着说：终点站，是您最想去的地方。",
      },
      {
        title: "第 9 集 · 第三节车厢",
        content:
          "每节车厢遵循不同的规则。有人用记忆换车票，有人用时间换位置，而祁野发现自己记得的，竟然是最不该记得的事。",
      },
      {
        title: "第 20 集 · 终点站骗局",
        content:
          "所谓故乡，是列车循环播放的一段最美好的记忆。真相揭开后，乘客们必须决定：留在谎言里，还是回到空无一物的现实。",
      },
      {
        title: "第 30 集 · 有人下车了",
        content:
          "列车减速的一刻，祁野选择了下车。宇宙空无一物，但这一次，方向由他自己定。",
      },
    ],
    tags: ["科幻", "脑洞", "单元结构"],
  },
  {
    id: "t-kitchen",
    title: "深夜食堂夜话",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["生活", "治愈", "美食"],
    rating: 8.8,
    director: "孟照",
    cast: ["老周", "林小满", "阿崧"],
    duration: "全 20 集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20cozy%20drama%20tv%20poster%2C%20warm%20orange%20lamp%20glow%20in%20a%20tiny%20late%20night%20eatery%2C%20deep%20blue%20shadows%20outside%20the%20window%2C%20steaming%20bowl%20on%20the%20counter%2C%20intimate%20healing%20mood%2C%20film%20grain%2C%20no%20text%2C%20no%20letters&width=600&height=900&seq=kitchen-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20film%20still%2C%20small%20cozy%20late%20night%20eatery%20with%20warm%20orange%20lanterns%2C%20deep%20blue%20rainy%20street%20outside%2C%20steam%20rising%20from%20dishes%2C%20comforting%20intimate%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=kitchen-backdrop-01&orientation=landscape",
    synopsis:
      "城市深夜十二点后开门的小食堂，菜单只有一道菜——你此刻最想吃的。老板老周不问来处，只听故事，用一顿饭的温度陪每个失眠的人走到天亮。",
    plot: [
      {
        title: "第 1 集 · 一碗阳春面",
        content:
          "第一位客人点了最简单的面，却吃到一半就哭了。老周什么也没问，只是默默续了半碗汤。",
      },
      {
        title: "第 7 集 · 加班的人",
        content:
          "连续加班的女孩每晚都来，点的菜越来越咸。老周说她缺的不是盐，是有人对她说一句辛苦了。",
      },
      {
        title: "第 14 集 · 老板的秘密",
        content:
          "常客们终于知道，老周的菜单上没有招牌菜，因为他一直在等一个再也不会来点单的人。",
      },
      {
        title: "第 20 集 · 天亮之前",
        content:
          "最后一集，所有客人都来了。他们没说什么大道理，只是一起把碗吃得干干净净——这就是深夜食堂的答案。",
      },
    ],
    tags: ["治愈", "单元剧", "下饭神剧"],
  },
];

export const regions = ["中国大陆", "中国香港", "中国台湾", "美国", "日本", "韩国"];

export const movieGenres = ["悬疑", "剧情", "历史", "战争", "犯罪", "科幻", "爱情", "心理", "黑色", "冒险"];
export const tvGenres = ["历史", "正剧", "剧情", "悬疑", "犯罪", "推理", "都市", "情感", "群像", "科幻", "生活", "治愈", "美食", "冒险"];